import { GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import ConflictCommission from "~/views/conflict-commission"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const crumbs = generateCrumbs(req?.url)
  return { crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
ConflictCommission.getInitialProps = getInitialProps

export default ConflictCommission
